// extracted by mini-css-extract-plugin
export default {"HeaderMenu":"HeaderMenu_HeaderMenu__GfLXi","MenuItem":"HeaderMenu_MenuItem__GPkSG"};